export const config = {
  appPort: process.env.PORT || 3000,
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || "http://localhost:3030/api",
  filesBaseUrl: process.env.REACT_APP_FILES_BASE_URL || "http://localhost:3030",
};
